var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"date-wrapper"},[_c('div',{staticClass:"calendar-week"},[_c('button',{staticClass:"meals-date",attrs:{"id":"meals-datepicker","data-date-start-date":_vm.programmeStartDate,"data-date-end-date":"0d"}},[_vm._v(_vm._s(_vm.weekNumber+_vm.__('. programme week')))]),_vm._v(" "),_c('span')])])
}
var staticRenderFns = []

export { render, staticRenderFns }